import { render, staticRenderFns } from "./WasteDestination.vue?vue&type=template&id=e5c9d0d2&"
import script from "./WasteDestination.vue?vue&type=script&lang=js&"
export * from "./WasteDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports